import React, { memo, useContext, useMemo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import ToggleSelector from 'Pods/ThreeDStudio/Shared/ToggleSelector/ToggleSelector'
import { providerSupportsParam } from 'Pods/ThreeDStudio/Shared/Utils/providerSupportsParam'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setExtraQuality } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

const handleExtraQualityToggle = (extraQuality) => {
  trackSettingsInteraction('ultra_mode', extraQuality)
  setExtraQuality(extraQuality)
}

function ExtraQualitySelector() {
  const t = useTranslation()
  const { enableExtraQuality, extractingCoreStyles } = useContext(ThreeDStudioPageContext)
  const generationAction = useThreeDStudioStore(state => state.schema.generationAction)
  const generationProvider = useThreeDStudioStore(state => state.schema.generationProvider)
  const isSupported = useMemo(
    () => providerSupportsParam(generationAction, generationProvider, 'ultra_mode'),
    [generationAction, generationProvider],
  )
  // Rendered during critical-CSS extraction regardless of the flag and of the engine
  // active on load, so the row's styles always make it into the generated stylesheet.
  const isVisible = extractingCoreStyles || (enableExtraQuality && isSupported)

  const trailing = useMemo(() => (
    <span className="extra-quality-selector">
      <span className="extra-quality-selector__badge">
        <span className="extra-quality-selector__badge-text cgt-overline-sm">
          {t('leftSide.extraQuality.badge')}
        </span>
      </span>
      <span className="extra-quality-selector__hint cgt-caption">
        {t('leftSide.extraQuality.hint')}
      </span>
    </span>
  ), [t])

  if (!isVisible) {
    return null
  }

  return (
    <ToggleSelector
      id="model-settings-extra-quality"
      keyName="extraQuality"
      label={t('leftSide.extraQuality.label')}
      setFunction={handleExtraQualityToggle}
      sliceName="modelSettings"
      trailing={trailing}
    />
  )
}

export default memo(ExtraQualitySelector)
